import React, {useState} from 'react'
import FieldProto from "../../../../../proto/field-proto";
import {FieldViewSize} from "../../../../../const";

type Props = {
    className?  : string

    field       : FieldProto
    value       : Moment

    onClick     : callback      // open dropdown
    onReset?    : callback
    children    : any


}

export default function FieldTimeOfDay_ListValueNotEmpty(props: Props) {


    const size : FieldViewSize = _.get(props, 'size', FieldViewSize.SMALL) as FieldViewSize

    const [isHovered, setIsHovered] = useState(false)

    const onMouseEnter = () => {
        if (!isHovered) setIsHovered(true)
    }

    const onMouseLeave = () => {
        if (isHovered) setIsHovered(false)
    }

    const onDeleteClick = (e:React.SyntheticEvent) => {
        e.stopPropagation()
        props.onReset && props.onReset()
    }


    const className = Classes("ui5-field-editable", "size-"+size, props.className, {
        'is-hovered'        : isHovered || props.children
    })

    const valueClass = Classes('txt-truncate', {
        'ui5-txt-default'                   : size === FieldViewSize.DEFAULT,
        'ui5-txt-less-important-small'      : size === FieldViewSize.SMALL,
    })

    if (isHovered || props.children) {
        return (
            <React.Fragment>
                <div className={className} onClick={props.onClick} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
                    <div className={valueClass}>{props.field.getDisplayValue(props.value)}</div>
                    <div className="buttons">
                        <div className="btn-reset" onClick={onDeleteClick} />
                        {/*<div className="btn-arrow"/>*/}
                    </div>
                </div>
                {props.children}
            </React.Fragment>
        )
    }

    // not hovered
    return (
        <React.Fragment>

            <div className={Classes(className, valueClass)} onClick={props.onClick} onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
                <div>{props.field.getDisplayValue(props.value)}</div>
            </div>
            {props.children}
        </React.Fragment>
    )



    // const valueClasses = Classes("ui5-txt-less-important-small ui5-field-dropdown-list-editable", props.className)
    //
    // return (
    //     <>
    //         <div className={valueClasses} onClick={props.onClick}>
    //             {formatTime(props.value)}
    //         </div>
    //         {props.children}
    //     </>
    // );


}
